import { appSdkAssetBaseFor } from '@doss/guest-frame/app-sdk'

export const config = {
  adminBaseUrl: 'admin.doss.com',
  apiBaseUrl: 'api.doss.com',
  webBaseUrl: 'app.doss.com',
  webhooksBaseUrl: 'webhooks.doss.com',
  docuforgeBaseUrl: 'docuforge.doss.com',
  appSdkAssetBase: appSdkAssetBaseFor('production'),
  sentryUrl:
    'https://819f3f17d2ab4a958e31abc91fdfa8b1@o4504896410025984.ingest.sentry.io/4505035079483392',
  logrocketId: 'l3k4df/doss-web',
  protocol: 'https',
  websocketProtocol: 'wss',
  jitsuHost: 'https://jitsu.doss.com',
  jitsuWriteKey: 'IBU8vGzQQikIfRXzAQlFaL1RSy0AhcLF:yXpCpJppIRBg20ZaW4WHMeQWsIRmFhGU',
  analyticsJitsuEnabled: true,
  perfTelemetryEnabled: true,
  stripePublishableKey:
    'pk_live_51LoEBoIr04lJNUdfujBqaV2VnPBCgH4YDnGl195sFqL34l1BQ7wTDgHzp9ZhJdvBeQGTgC0KjtcNsPRdywNPsYQ800RHHwKltJ',
  gcpServiceAccountEmail: '864593434442-compute@developer.gserviceaccount.com',
  stripeStagingPublishableKey:
    'pk_test_51LoEBoIr04lJNUdf2K625ZzB9nCgCsGHbqV16AnqzvpCXT63ggox6GgwetYTBHgUeJwFXY9zuQL3TdyCNHrhr51f00W38Np6C3',
  loopReturnsInstallUrl:
    'https://admin.loopreturns.com/third-party-integration/install/c986e3b5-6de4-47ce-9b67-cdc393b17348',
}
